module.exports = __webpack_public_path__ + "images/check_white156b442b540ed918f0846e8ae445a8d9.svg";